// Fix #1: API key is now loaded from environment variable, never hardcoded in source
// Fix #10: Removed hardcoded production fallback URL — will throw if env var is missing
if (!process.env.REACT_APP_API_URL) {
  throw new Error('REACT_APP_API_URL is not set. Check your .env file.');
}

let rawUrl = process.env.REACT_APP_API_URL;
if (rawUrl.endsWith('/')) {
  rawUrl = rawUrl.slice(0, -1);
}
export const BASE_URL = rawUrl;

const getApiKey = () => process.env.REACT_APP_API_KEY || '';

export const apiRequest = async (endpoint, options = {}) => {
  const token = localStorage.getItem('accessToken');

  // 1. Prepare Headers
  const headers = {
    'Content-Type': 'application/json',
    'X-Api-Key': getApiKey(),
    ...options.headers,
  };

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  // 2. Make the original request
  let response = await fetch(`${BASE_URL}${endpoint}`, { ...options, headers });

  // 3. Handle Token Expiration (401)
  if (response.status === 401) {
    const refreshToken = localStorage.getItem('refreshToken');

    if (refreshToken) {
      try {
        // Attempt to get a new Access Token
        const refreshRes = await fetch(`${BASE_URL}/auth/refresh`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Api-Key': getApiKey(),
          },
          body: JSON.stringify({ refreshToken }),
        });

        if (refreshRes.ok) {
          const data = await refreshRes.json();

          // Update localStorage with new tokens
          localStorage.setItem('accessToken', data.accessToken);
          if (data.refreshToken) {
            localStorage.setItem('refreshToken', data.refreshToken);
          }

          // 4. Retry original request with the NEW token
          headers['Authorization'] = `Bearer ${data.accessToken}`;
          response = await fetch(`${BASE_URL}${endpoint}`, { ...options, headers });
        } else {
          // Refresh token is also invalid/expired
          throw new Error('Refresh failed');
        }
      } catch (err) {
        // Full logout if refresh fails
        window.dispatchEvent(new Event('auth-logout'));
      }
    } else {
      // No refresh token available
      window.dispatchEvent(new Event('auth-logout'));
    }
  }

  return response;
};